import { render, staticRenderFns } from "./serial-search.vue?vue&type=template&id=bc1c0814"
import script from "./serial-search.vue?vue&type=script&lang=js"
export * from "./serial-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports